import React, { useContext, useState, useEffect } from 'react'
import { LotContext } from '../Lot/LotContext'
import { WemoloTypography } from '../../components/Wemolo'
import { getOccupancyDisplayUI, useGetSCSDeviceCurrentValue } from '../Lot/utils'
import { LotStationType } from '../Lot/lot-types'
import { DateTime } from 'luxon'
import styles from './LotOccupancyFreeSpaces.module.css'

export const LotOccupancyFreeSpaces = ({ lotStation }: { lotStation: LotStationType }) => {
    const scsDeviceSpaceId =
        lotStation.device_uuid?.split('_')[0] === 'scs' ? lotStation.device_uuid?.split('_')[1] : null
    const { data, refetch } = useGetSCSDeviceCurrentValue(scsDeviceSpaceId)

    const displaySecondScreen =
        lotStation.config?.display_mode?.mode === 'overwrite' ||
        lotStation.config?.display_mode?.mode === 'clock' ||
        lotStation.config?.display_mode?.mode === 'disable'

    const { occupancyValue, fetchOccupancyValue, lastFetchOccupancy, refetchLotStations } = useContext(LotContext)
    const [secondsAgo, setSecondsAgo] = useState(0)
    useEffect(() => {
        const interval = setInterval(() => {
            if (lastFetchOccupancy) {
                const elapsed = Math.floor((Date.now() - new Date(lastFetchOccupancy).getTime()) / 1000)
                setSecondsAgo(elapsed)
            } else {
                setSecondsAgo(0)
            }
        }, 1000)

        return () => clearInterval(interval)
    }, [lastFetchOccupancy])

    if (!occupancyValue) {
        return <div>-</div>
    }
    const freeSpaces = occupancyValue?.free_spaces || 0

    return (
        <div className={styles.root}>
            {getOccupancyDisplayUI(occupancyValue?.free_spaces?.toString(), freeSpaces > 0, displaySecondScreen)}
            {displaySecondScreen && data ? (
                <>
                    <i className={`wemolo-arrow-right ${styles.arrow}`} />
                    {getOccupancyDisplayUI(
                        (data.content === ':clock'
                            ? lastFetchOccupancy
                                ? DateTime.fromJSDate(lastFetchOccupancy).toFormat('HH:mm')
                                : undefined
                            : data.content) ?? undefined,
                        data.color ?? undefined
                    )}
                </>
            ) : null}
            <div className={styles.meta}>
                <WemoloTypography variant="label-xsmall" tag="div" className={styles.metaTime}>
                    {secondsAgo}s ago
                </WemoloTypography>
                <button
                    onClick={() => {
                        fetchOccupancyValue()
                        if (scsDeviceSpaceId) refetch()
                        refetchLotStations()
                    }}
                    className={styles.refreshButton}
                >
                    <i className="material-icons">refresh</i>
                </button>
            </div>
        </div>
    )
}
